var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "activities-tab-navbar",
        [
          _c(
            "v-btn",
            {
              attrs: { small: "", text: "", icon: "", color: "accent" },
              on: { click: _vm.exitActivityDetails }
            },
            [_c("v-icon", [_vm._v("arrow_back_ios")])],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { staticClass: "subheading font-weight-bold" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$tc("Activity", 1)) +
                " " +
                _vm._s(_vm.activity.title) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _vm.mode === "tasks"
            ? _c("list-edition-toolbar", {
                attrs: {
                  buttons: _vm.toolbarButtons,
                  "horizontal-alignment": "right"
                },
                on: {
                  add: function($event) {
                    return _vm.$emit("addTask")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("toggle-buttons", {
            staticStyle: { margin: "6px 8px" },
            attrs: { buttons: _vm.toggleButtons },
            model: {
              value: _vm.mode,
              callback: function($$v) {
                _vm.mode = $$v
              },
              expression: "mode"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.mode === "details"
        ? _c("activity-form", {
            attrs: { activity: _vm.activity, tasks: _vm.tasks },
            on: { update: _vm.getActivity, delete: _vm.exitActivityDetails }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.mode !== "details"
        ? _c("tasks-table", {
            attrs: { tasks: _vm.tasks },
            on: {
              openTask: function($event) {
                return _vm.$emit("openTask", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71c00ce8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c00ce8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/ActivityDetails/ActivityDetails.vue
// module id = null
// module chunks = 